import { useSelector } from 'react-redux';
import { Navigate, useLocation } from 'react-router-dom';

const RequireVisitedDetail = ({ children }) => {
  const hasVisitedDetail = useSelector(
    (state) => state.details.visitedUserDetails
  );
  const location = useLocation();

  if (!hasVisitedDetail) {
    return (
      <Navigate
        to={`/detail?redirect=${encodeURIComponent(location.pathname)}`}
        replace
      />
    );
  }

  return children;
};

export default RequireVisitedDetail;
